import React, { useEffect, useState } from 'react';
import { FiDownload, FiPlus } from 'react-icons/fi';
import { RiProhibited2Line } from 'react-icons/ri';
import { StudyGuideMatterModal } from './study-guide-matter-modal';
import { StudyGuideMatterDataGrid } from './study-guide-matter-data-grid';
import { useClient } from 'jsonapi-react';
import xlsx from 'json-as-xlsx';
import { DashboardContent } from '@/layouts/dashboard';
import { GuideCustom, GuideCustomHeader, GuideCustomTitle, GuideCustomText, GuideCustomBody } from '@/components/custom/guide';
import { Button, ButtonIcon } from '@/components/ui/button';

export function StudyGuideSettings(props) {
  const { uri } = props;

  const [showModal, setShowModal] = useState(false);
  const [taxonomies, setTaxonomies] = useState([]);
  const [modalTaxonomies, setModalTaxonomies] = useState([]);

  const client = useClient();

  const getUserTaxonomies = async () => {
    const response = await client.fetch('user_taxonomies');
    return response.data;
  };

  useEffect(() => {
    getUserTaxonomies().then(data => {
      const ableTaxonomies = data.filter(taxonomy => taxonomy.status !== 'disabled');
      const modalTaxonomies = data.filter(taxonomy => taxonomy.status === 'disabled');
      setTaxonomies(ableTaxonomies);
      setModalTaxonomies(modalTaxonomies);
    });
  }, [showModal]);

  const breadcrumbs = {
    title: 'Aprendizado Dinâmico',
    nav: [
      {
        route: '/guia-de-estudos',
        name: 'Guia de estudos',
        isActive: false
      },
      {
        route: uri,
        name: 'Customização do Guia',
        isActive: true
      }
    ]
  };

  const xlsxStructure = [
    {
      sheet: 'Matérias',
      columns: [
        { label: 'Matéria', value: 'Matéria' },
        { label: 'Submatéria', value: 'Submatéria' }
      ],
      content: taxonomies?.map(item => ({
        Matéria: item['taxonomy-name'],
        Submatéria: item['taxonomy-children'].map(item => item.name).join(', ')
      }))
    }
  ];

  const handleDownloadCSV = () => {
    try {
      xlsx(xlsxStructure);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <GuideCustom>
        <GuideCustomHeader>
          <GuideCustomTitle>
            Aqui estão as <strong>{taxonomies.length} matérias</strong> que já estão no seu Guia.
          </GuideCustomTitle>

          {false && (
            <Button variant="outline">
              <ButtonIcon size="md">
                <RiProhibited2Line />
              </ButtonIcon>
              Bloquear matérias
            </Button>
          )}

          <Button
            variant="outline"
            onClick={handleDownloadCSV}
          >
            <ButtonIcon size="md">
              <FiDownload />
            </ButtonIcon>
            Baixar
          </Button>
        </GuideCustomHeader>

        <GuideCustomBody>
          <GuideCustomText>Você pode adicionar, remover ou bloquear conforme suas prioridades. As mudanças entram em vigor na próxima semana</GuideCustomText>

          <Button
            variant="outline-dashed"
            size="sm"
            fullWidth
            onClick={() => setShowModal(true)}
          >
            <ButtonIcon>
              <FiPlus />
            </ButtonIcon>{' '}
            Adicionar outras matérias
          </Button>

          {modalTaxonomies && (
            <StudyGuideMatterModal
              show={showModal}
              onClose={() => setShowModal(false)}
              taxonomies={modalTaxonomies}
            />
          )}

          {taxonomies && <StudyGuideMatterDataGrid data={taxonomies} />}
        </GuideCustomBody>
      </GuideCustom>
    </DashboardContent>
  );
}
